import axios from 'axios'

// Get all users from business
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/business-user`)
  return data
}

// Get user from id
const get = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/business-user/${id}`)
  return data
}

// Create business user
const create = async (
  login,
  password,
  password2,
  name,
  profile
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/business-user`, {
    login,
    password,
    password2,
    name,
    profile
  })
  return data
}

// Update business user
const update = async (
  id,
  login,
  password,
  password2,
  name,
  profile,
  userId
) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/business-user/${id}`, {
    login,
    password,
    password2,
    name,
    profile,
    userId
  })
  return data
}

// Remove business user
const remove = async (id) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/business-user/${id}`)
  return data
}

export {
  getAll,
  get,
  create,
  update,
  remove
}
